import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1 className="text-danger ">404</h1>
        </div>
    );
};

export default NotFound;